import { api } from './client';
import type { UserListResponse, UserDetailResponse, UserScansResponse } from './types';

export function getUsers(params: { page: number; limit?: number; search?: string }) {
  const qs = new URLSearchParams({ page: String(params.page) });
  if (params.limit) qs.set('limit', String(params.limit));
  if (params.search) qs.set('search', params.search);
  return api.get<UserListResponse>(`/api/admin/users?${qs}`);
}

export function getUser(id: string) {
  return api.get<UserDetailResponse>(`/api/admin/users/${encodeURIComponent(id)}`);
}

export function getUserScans(id: string, params: { page: number; limit?: number }) {
  const qs = new URLSearchParams({ page: String(params.page) });
  if (params.limit) qs.set('limit', String(params.limit));
  return api.get<UserScansResponse>(`/api/admin/users/${encodeURIComponent(id)}/scans?${qs}`);
}
